'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactMotion = require('react-motion');

require('./styles.sass');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var RadialProgress = function RadialProgress(_ref) {
  var size = _ref.size,
      progress = _ref.progress,
      thickness = _ref.thickness,
      stroke = _ref.stroke,
      ringStroke = _ref.ringStroke,
      roundedLine = _ref.roundedLine;
  return _react2.default.createElement(
    'div',
    { className: 'RadialProgress' },
    _react2.default.createElement(
      'svg',
      { width: size + thickness * 2, height: size + thickness * 2, className: 'RadialProgress__svg' },
      _react2.default.createElement('circle', {
        className: 'RadialProgress__circle',
        cx: size / 2 + thickness,
        cy: size / 2 + thickness,
        r: size / 2,
        stroke: ringStroke,
        strokeWidth: thickness
      }),
      _react2.default.createElement(
        _reactMotion.Motion,
        {
          defaultStyle: {
            progress: 0
          },
          style: {
            progress: (0, _reactMotion.spring)(progress)
          }
        },
        function (value) {
          return _react2.default.createElement('path', {
            className: 'RadialProgress__path',
            strokeWidth: thickness,
            stroke: stroke,
            strokeLinecap: roundedLine ? 'round' : 'none',
            strokeDasharray: _progressToDasharray(value.progress, size),
            d: _path(size, thickness)
          });
        }
      )
    )
  );
};

RadialProgress.defaultProps = {
  size: 80,
  progress: 0,
  thickness: 5,
  stroke: '#40a0f4',
  ringStroke: '#eaeaea'
};

RadialProgress.propTypes = {
  size: _propTypes2.default.number,
  progress: _propTypes2.default.number,
  thickness: _propTypes2.default.number,
  stroke: _propTypes2.default.string,
  ringStroke: _propTypes2.default.string,
  roundedLine: _propTypes2.default.bool
};

exports.default = RadialProgress;

/**
 * Generates a path based on size and stroke width.
 */

function _path(size, strokeWidth) {
  var half = size / 2;
  return '\n    M' + (half + strokeWidth) + ' ' + strokeWidth + '\n    a ' + half + ' ' + half + ' 0 0 1 0 ' + size + '\n    a ' + half + ' ' + half + ' 0 0 1 0 -' + size + '\n  ';
}

/**
 * Calculates the correct dasharray to emulate the progress
 * effect.
 *
 * Explanation (for myself when I forget):
 * The trick is to set the length of each dash to
 * whatever % of the circumference we're at, and at the
 * same time make sure the gap between each stroke is far
 * enough so only a single one is displayed at any time.
 */
function _progressToDasharray(progress, size) {
  var circumference = size * Math.PI; // mmmm, could go for some pie
  // Length of the stroke
  var length = progress / 100 * circumference;
  // The gap which will make sure only a single "dash" is drawn.
  var gap = circumference - length;
  return length + ',' + gap;
}
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@taxfyle/web-commons/lib/components/RadialProgress/index.js
// module id = 383
// module chunks = 0